import { copy } from '@/content/copy';

export function Hero() {
  return (
    <section
      id="music"
      aria-labelledby="hero-title"
      className={[
        'relative flex items-center overflow-hidden bg-night',
        'h-[min(88vh,900px)] min-h-[640px]',
        'max-[560px]:h-[min(78svh,740px)] max-[560px]:max-h-[740px] max-[560px]:min-h-[560px]',
      ].join(' ')}
    >
      <div className="absolute inset-0 z-0 overflow-hidden bg-night">
        <img
          src="/assets/hero.jpg"
          alt={copy.hero.imageAlt}
          width={1375}
          height={784}
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover object-[68%_center] grayscale contrast-[1.04] max-[560px]:object-[32%_center]"
        />
      </div>

      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-[1] bg-[linear-gradient(90deg,#050506_0%,rgba(5,5,6,0.94)_24%,rgba(5,5,6,0.66)_39%,rgba(5,5,6,0.08)_70%,transparent_100%)] max-[560px]:bg-[linear-gradient(90deg,rgba(5,5,6,0.94)_0%,rgba(5,5,6,0.8)_43%,rgba(5,5,6,0.36)_76%,rgba(5,5,6,0.08)_100%)]"
      />

      <div className="relative z-[2] ml-[clamp(24px,2.5vw,42px)] w-[min(45%,540px)] pt-[72px] max-[860px]:w-[52%] max-[860px]:max-w-[440px] max-[860px]:pt-[62px] max-[560px]:ml-0 max-[560px]:w-[min(86%,380px)] max-[560px]:px-5 max-[560px]:py-6">
        <h1
          id="hero-title"
          className="grid gap-0 font-serif font-semibold uppercase leading-[0.9] tracking-[0.045em] text-[#f4f0ed] text-[clamp(3.2rem,5.4vw,5.8rem)] max-[560px]:text-[clamp(2.1rem,8.8vw,3.15rem)] max-[560px]:tracking-[0.03em]"
        >
          {copy.hero.lines.map((line) => (
            <span key={line} className="block">
              {line}
            </span>
          ))}
        </h1>

        <p className="mt-[26px] mb-7 font-serif text-[1.12rem] leading-[1.35] text-[#e0d9d6] max-[560px]:mt-[18px] max-[560px]:mb-[22px] max-[560px]:text-base">
          {copy.hero.blurb[0]}
          <br />
          {copy.hero.blurb[1]}
        </p>

        <a
          href="#shop"
          className="inline-block min-w-[235px] border border-[#f4f0ed] bg-[#f4f0ed] px-7 py-[15px] text-center text-[0.83rem] font-semibold uppercase tracking-[0.12em] text-[#111] transition-colors duration-200 hover:bg-transparent hover:text-white max-[560px]:w-[min(100%,290px)] max-[560px]:min-w-0 max-[560px]:px-[22px] max-[560px]:py-[13px] max-[560px]:text-[0.76rem]"
        >
          {copy.hero.cta}
        </a>
      </div>

      <a
        href="#shop"
        aria-label={copy.hero.scroll}
        className="absolute bottom-5 left-1/2 z-[2] -translate-x-1/2 text-[2.2rem] leading-none text-[#f4f0ed] transition-opacity hover:opacity-70 max-[560px]:bottom-3.5 max-[560px]:text-[1.8rem]"
      >
        ↓
      </a>
    </section>
  );
}
